"use client"

import { useState } from "react"
import { Search, Wifi, Volume2, Battery, MessageSquare } from "lucide-react"

interface Window {
  id: string
  title: string
  isMinimized: boolean
}

interface TaskbarProps {
  onStartClick: () => void
  windows: Window[]
  onWindowClick: (id: string) => void
}

const Taskbar = ({ onStartClick, windows, onWindowClick }: TaskbarProps) => {
  const [currentTime, setCurrentTime] = useState(new Date())

  // Update time every minute
  useState(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date())
    }, 60000)

    return () => clearInterval(timer)
  })

  const formattedTime = currentTime.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  const formattedDate = currentTime.toLocaleDateString([], { month: "short", day: "numeric", year: "numeric" })

  return (
    <div className="absolute bottom-0 left-0 right-0 h-12 bg-black bg-opacity-80 backdrop-blur-md flex items-center px-2 z-50">
      <div className="flex items-center h-full">
        {/* Start Button */}
        <button
          id="taskbar-start-button"
          className="w-10 h-10 flex items-center justify-center rounded-md hover:bg-white hover:bg-opacity-10 transition-colors"
          onClick={onStartClick}
        >
          <div className="w-6 h-6 bg-blue-500 rounded-md grid grid-cols-2 gap-0.5 p-0.5">
            <div className="bg-white rounded-sm"></div>
            <div className="bg-white rounded-sm"></div>
            <div className="bg-white rounded-sm"></div>
            <div className="bg-white rounded-sm"></div>
          </div>
        </button>

        {/* Search */}
        <button className="w-10 h-10 flex items-center justify-center rounded-md hover:bg-white hover:bg-opacity-10 transition-colors ml-1">
          <Search className="w-5 h-5 text-white" />
        </button>

        {/* Task buttons */}
        <div className="flex items-center h-full ml-2 space-x-1">
          {windows.map((window) => (
            <button
              key={window.id}
              className={`h-10 px-3 flex items-center justify-center rounded-md transition-colors ${
                !window.isMinimized ? "bg-white bg-opacity-10" : "hover:bg-white hover:bg-opacity-10"
              }`}
              onClick={() => onWindowClick(window.id)}
            >
              <span className="text-white text-sm truncate max-w-[100px]">{window.title}</span>
            </button>
          ))}
        </div>
      </div>

      {/* System Tray */}
      <div className="ml-auto flex items-center h-full">
        <button className="px-2 h-10 flex items-center justify-center rounded-md hover:bg-white hover:bg-opacity-10 transition-colors">
          <Wifi className="w-4 h-4 text-white" />
        </button>
        <button className="px-2 h-10 flex items-center justify-center rounded-md hover:bg-white hover:bg-opacity-10 transition-colors">
          <Volume2 className="w-4 h-4 text-white" />
        </button>
        <button className="px-2 h-10 flex items-center justify-center rounded-md hover:bg-white hover:bg-opacity-10 transition-colors">
          <Battery className="w-4 h-4 text-white" />
        </button>
        <button className="px-2 h-10 flex items-center justify-center rounded-md hover:bg-white hover:bg-opacity-10 transition-colors">
          <MessageSquare className="w-4 h-4 text-white" />
        </button>
        <button className="px-3 h-10 flex flex-col items-end justify-center rounded-md hover:bg-white hover:bg-opacity-10 transition-colors">
          <div className="text-white text-xs">{formattedTime}</div>
          <div className="text-white text-xs">{formattedDate}</div>
        </button>
      </div>
    </div>
  )
}

export default Taskbar

